import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Checkbox,
  Dropdown,
  Icon,
  Table,
  Grid,
} from 'semantic-ui-react';
import ThemeSelector from '../../themes/theme-selector';
import { OPTIONAL_COLUMN_COUNT } from '../influencer-table-settings';

const greenLinkStyle = {
  color: '#20c49e',
  cursor: 'pointer',
};

const redLinkStyle = {
  color: '#ef3a50',
  cursor: 'pointer',
};

const greyLinkStyle = {
  color: 'grey',
  cursor: 'not-allowed',
};

const clippedDropdownFix = {
  overflow: 'visible',
};

const PER_PAGE = 25;
const ALWAYS_VISIBLE_COLUMNS = 5;

const InfluencerActions = props => {
  const {
    reportUrls,
    shortlists,
    count,
    onCheckAll,
    onDelete,
    onSaveShortlist,
    onShortlistPatch,
    columnsSettings: { columns },
  } = props;

  const { hideInfluencerImportExport } = ThemeSelector.theme();

  const exportLinkStyle = reportUrls && reportUrls.xlsx ? greenLinkStyle : greyLinkStyle;
  const displayedColumns = (ALWAYS_VISIBLE_COLUMNS + OPTIONAL_COLUMN_COUNT)
    - _.filter(_.values(columns), ({ displayed }) => !displayed).length;

  return (
    <Table.Row>
      <Table.HeaderCell verticalAlign="middle" textAlign="center" width={1} colSpan={1}>
        <Checkbox checked={PER_PAGE === count} onChange={onCheckAll} />
      </Table.HeaderCell>
      <Table.HeaderCell width={4} colSpan={1}>
        {count} selected
      </Table.HeaderCell>
      <Table.HeaderCell width={11} colSpan={displayedColumns - 2} style={clippedDropdownFix}>
        <Grid>
          <Grid.Column width={4}>
            <Dropdown
              text="shortlists"
              labeled
              button
              icon="clipboard"
              fluid
              className="icon tiny pink ui button"
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  content="new shortlist..."
                  icon="plus"
                  onClick={onSaveShortlist}
                />
                <Dropdown.Divider />
                <Dropdown.Header icon="clipboard" content="existing shortlist" />
                <Dropdown.Menu scrolling>
                  { _.map(shortlists, list =>
                    <Dropdown.Item
                      key={list.id}
                      text={list.name}
                      value={list.id}
                      onClick={onShortlistPatch}
                      icon="clipboard"
                    />,
                  )}
                </Dropdown.Menu>
              </Dropdown.Menu>
            </Dropdown>
          </Grid.Column>
          <Grid.Column width={4} textAlign="center">
            {!hideInfluencerImportExport &&
            <a
              href={reportUrls && reportUrls.xlsx ? reportUrls.xlsx : '#'}
              style={exportLinkStyle}
            >
              <Icon.Group>
                <Icon name="cloud download" />
          export
              </Icon.Group>
            </a>
            }
          </Grid.Column>
          <Grid.Column width={4} textAlign="center">
            {!hideInfluencerImportExport &&
            <a
              rel="noopener noreferrer"
              target="_blank"
              style={greenLinkStyle}
              href="https://dyzio.co/adding-your-influencers-by-spreadsheet"
            >
              <Icon.Group>
                <Icon name="cloud upload" />
        import
              </Icon.Group>
            </a>
            }
          </Grid.Column>
          <Grid.Column width={4} textAlign="right">
            <a
              style={redLinkStyle}
              onClick={onDelete}
            >
              <Icon.Group>
                <Icon name="delete" />
        delete
              </Icon.Group>
            </a>

          </Grid.Column>
        </Grid>
      </Table.HeaderCell>
    </Table.Row>
  );
};

InfluencerActions.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onCheckAll: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  shortlists: PropTypes.array.isRequired,
  onSaveShortlist: PropTypes.func.isRequired,
  onShortlistPatch: PropTypes.func.isRequired,
  reportUrls: PropTypes.object.isRequired,
  columnsSettings: PropTypes.object.isRequired,
};

export default InfluencerActions;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-actions/index.js
 **/